import React from "react";
import {
    PortalMetricCard,
    PortalMetricGrid,
    PortalMetricLabel,
    PortalMetricValue,
    PortalHighlightMetricCard
} from "src/components";

export default function LicensesOverview(props) {
    const { licensesOverview } = props;
    const stats = [
        ["Total Active Licenses", licensesOverview.active ?? 0],
        ["Total Expired Licenses", licensesOverview.expired ?? 0],
        ["Total Active Trials", licensesOverview.activeTrials ?? 0],
        ["Total Licenses Not Started", licensesOverview.notStarted ?? 0],
    ];

    return (
        <PortalMetricGrid columns={4}>
            {stats.map(([label, value], index) => {
                const MetricCard = index === 0 ? PortalHighlightMetricCard : PortalMetricCard;

                return (
                    <MetricCard key={label} minHeight="6.25rem">
                        <PortalMetricLabel>{label}</PortalMetricLabel>
                        <PortalMetricValue size="1.75rem">{value}</PortalMetricValue>
                    </MetricCard>
                );
            })}
        </PortalMetricGrid>
    );
}
